import { ACTIONS } from '../../../constants';
import { IInputsFocusState, TInputsFocusActions } from './types';

const initialState: IInputsFocusState = {
  search: true,
};

export const inputsFocusReducer = (state = initialState, action: TInputsFocusActions): IInputsFocusState => {
  switch (action.type) {
    case ACTIONS.INPUTS_FOCUS_SEARCH: {
      return {
        ...state,
        search: action.search,
      };
    }

    default:
      return state;
  }
};
